"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipPropTypes = exports.Tooltip = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = require("react-dom");
var _utils = require("../utils");
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _excluded = ["transition", "transitionProperty", "transitionDuration", "transitionTimingFunction", "transitionDelay", "transform", "padding", "opacity"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultTailHeight = 6;
var defaultOffset = 6;
var defaultOffsetBody = 0;
var getDefaultTransitionStyle = function getDefaultTransitionStyle(entering) {
  return {
    opacity: entering ? 1 : 0,
    transitionProperty: "opacity"
  };
};
var defaultStyle = {
  background: "#282828"
};
var defaultBoxStyle = {
  borderRadius: 4,
  padding: 8,
  color: "#fff"
};
var getTailHeight = function getTailHeight(width) {
  return width * 0.866;
};
var scrollRefPropType = _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Element), _propTypes["default"].object]);
var tooltipPropTypes = exports.tooltipPropTypes = {
  position: _propTypes["default"].oneOf(["top", "top-start", "top-end", "bottom", "bottom-start", "bottom-end", "left", "left-start", "left-end", "right", "right-start", "right-end"]),
  style: _propTypes["default"].object,
  boxStyle: _propTypes["default"].object,
  tailStyle: _propTypes["default"].object,
  getTransitionStyle: _propTypes["default"].func,
  boxClassName: _propTypes["default"].string,
  maskClassName: _propTypes["default"].string,
  tailClassName: _propTypes["default"].string,
  tailHeight: _propTypes["default"].number,
  offset: _propTypes["default"].number,
  offsetBody: _propTypes["default"].number,
  portalId: _propTypes["default"].string,
  pure: _propTypes["default"].bool,
  inline: _propTypes["default"].bool,
  interactive: _propTypes["default"].bool,
  autoFlip: _propTypes["default"].bool,
  scrollRef: scrollRefPropType,
  scrollRefs: _propTypes["default"].arrayOf(scrollRefPropType),
  listenToAllParentScrolls: _propTypes["default"].bool
};
var Tooltip = exports.Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);
  function Tooltip() {
    var _this;
    _classCallCheck(this, Tooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Tooltip, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      absoluteTop: 0,
      absoluteLeft: 0
    });
    _defineProperty(_assertThisInitialized(_this), "tooltipRef", /*#__PURE__*/(0, _react.createRef)());
    _defineProperty(_assertThisInitialized(_this), "sourceRect", {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    });
    _defineProperty(_assertThisInitialized(_this), "tooltipRect", {
      width: 0,
      height: 0
    });
    _defineProperty(_assertThisInitialized(_this), "portalRect", {
      top: 0,
      left: 0
    });
    _defineProperty(_assertThisInitialized(_this), "scrollParents", []);
    _defineProperty(_assertThisInitialized(_this), "throttling", false);
    _defineProperty(_assertThisInitialized(_this), "unmounted", false);
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setPosition();
      _this.findScrollParent();
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.unmounted = true;
      _this.scrollParents.forEach(function (el) {
        el.removeEventListener("scroll", _this.onScroll);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var prevSourceRef = prevProps.sourceRef,
        prevPortalId = prevProps.portalId;
      var _this$props = _this.props,
        sourceRef = _this$props.sourceRef,
        portalId = _this$props.portalId,
        pure = _this$props.pure,
        inline = _this$props.inline,
        position = _this$props.position,
        tailHeight = _this$props.tailHeight,
        offset = _this$props.offset,
        offsetBody = _this$props.offsetBody,
        autoFlip = _this$props.autoFlip;
      if (!pure || !(0, _utils.shallowEqualForeignProps)(_this.props, prevProps, Tooltip.propTypes)) {
        _this.setPosition();
      } else {
        if (portalId !== prevPortalId) {
          _this.setPortalRect();
        }
        if (sourceRef !== prevSourceRef) {
          _this.setSourceRect();
          _this.findScrollParent();
        }
        _this.memoizedSetPosition(position, tailHeight, offset, offsetBody, inline || !portalId, _this.sourceRect.top, _this.sourceRect.left, _this.sourceRect.width, _this.sourceRect.height, _this.tooltipRect.width, _this.tooltipRect.height, _this.portalRect.top, _this.portalRect.left, _this.portalRect.width, _this.portalRect.height, autoFlip);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setPosition", function () {
      var _this$props2 = _this.props,
        inline = _this$props2.inline,
        portalId = _this$props2.portalId,
        position = _this$props2.position,
        tailHeight = _this$props2.tailHeight,
        offset = _this$props2.offset,
        offsetBody = _this$props2.offsetBody,
        autoFlip = _this$props2.autoFlip;
      var _this$setSourceRect = _this.setSourceRect(),
        sourceTop = _this$setSourceRect.top,
        sourceLeft = _this$setSourceRect.left,
        sourceWidth = _this$setSourceRect.width,
        sourceHeight = _this$setSourceRect.height;
      var _this$setTooltipRect = _this.setTooltipRect(),
        tooltipWidth = _this$setTooltipRect.width,
        tooltipHeight = _this$setTooltipRect.height;
      var _this$setPortalRect = _this.setPortalRect(),
        portalTop = _this$setPortalRect.top,
        portalLeft = _this$setPortalRect.left,
        portalWidth = _this$setPortalRect.width,
        portalHeight = _this$setPortalRect.height;
      _this.memoizedSetPosition(position, tailHeight, offset, offsetBody, inline || !portalId, sourceTop, sourceLeft, sourceWidth, sourceHeight, tooltipWidth, tooltipHeight, portalTop, portalLeft, portalWidth, portalHeight, autoFlip);
    });
    _defineProperty(_assertThisInitialized(_this), "memoizedSetPosition", (0, _memoizeOne["default"])(function (position, tailHeight, offset, offsetBody, inline, sourceTop, sourceLeft, sourceWidth, sourceHeight, tooltipWidth, tooltipHeight, portalTop, portalLeft, portalWidth, portalHeight, autoFlip) {
      var totalOffset = tailHeight + offset;
      var finalPosition = position;
      var _this$getPosition = _this.getPosition(position, totalOffset, offsetBody, sourceTop, sourceLeft, sourceWidth, sourceHeight, tooltipWidth, tooltipHeight),
        top = _this$getPosition.top,
        left = _this$getPosition.left;
      if (autoFlip) {
        var splitPosition = position.split("-");
        var primaryPosition = splitPosition[0];
        var secondaryPosition = splitPosition[1];
        switch (primaryPosition) {
          case "left":
            if (left <= portalLeft) {
              primaryPosition = "right";
            }
            break;
          case "bottom":
            if (top + tooltipHeight >= portalTop + portalHeight) {
              primaryPosition = "top";
            }
            break;
          case "right":
            if (left + tooltipWidth >= portalLeft + portalWidth) {
              primaryPosition = "left";
            }
            break;
          default:
            if (top <= portalTop) {
              primaryPosition = "bottom";
            }
            break;
        }
        finalPosition = primaryPosition;
        if (secondaryPosition) {
          finalPosition += "-" + secondaryPosition;
        }
        if (finalPosition !== position) {
          var _this$getPosition2 = _this.getPosition(finalPosition, totalOffset, offsetBody, sourceTop, sourceLeft, sourceWidth, sourceHeight, tooltipWidth, tooltipHeight);
          top = _this$getPosition2.top;
          left = _this$getPosition2.left;
        }
      }
      _this.setState({
        top: top - portalTop - (inline ? sourceTop : 0),
        left: left - portalLeft - (inline ? sourceLeft : 0),
        absoluteTop: top,
        absoluteLeft: left,
        position: finalPosition
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "getPosition", function (position, totalOffset, offsetBody, sourceTop, sourceLeft, sourceWidth, sourceHeight, tooltipWidth, tooltipHeight) {
      var top = 0;
      var left = 0;
      switch (position) {
        case "left":
          top += (sourceHeight - tooltipHeight) / 2 + offsetBody;
          left -= tooltipWidth + totalOffset;
          break;
        case "left-start":
          top += offsetBody;
          left -= tooltipWidth + totalOffset;
          break;
        case "left-end":
          top += offsetBody - tooltipHeight + sourceHeight;
          left -= tooltipWidth + totalOffset;
          break;
        case "bottom":
          top += sourceHeight + totalOffset;
          left += (sourceWidth - tooltipWidth) / 2 + offsetBody;
          break;
        case "bottom-start":
          top += sourceHeight + totalOffset;
          left += offsetBody;
          break;
        case "bottom-end":
          top += sourceHeight + totalOffset;
          left += offsetBody - tooltipWidth + sourceWidth;
          break;
        case "right":
          top += (sourceHeight - tooltipHeight) / 2 + offsetBody;
          left += sourceWidth + totalOffset;
          break;
        case "right-start":
          top += offsetBody;
          left += sourceWidth + totalOffset;
          break;
        case "right-end":
          top += offsetBody - tooltipHeight + sourceHeight;
          left += sourceWidth + totalOffset;
          break;
        case "top-start":
          top -= tooltipHeight + totalOffset;
          left += offsetBody;
          break;
        case "top-end":
          top -= tooltipHeight + totalOffset;
          left += offsetBody - tooltipWidth + sourceWidth;
          break;
        default:
          top -= tooltipHeight + totalOffset;
          left += (sourceWidth - tooltipWidth) / 2 + offsetBody;
          break;
      }
      left += sourceLeft;
      top += sourceTop;
      return {
        top: top,
        left: left
      };
    });
    _defineProperty(_assertThisInitialized(_this), "setSourceRect", function () {
      var sourceRef = _this.props.sourceRef;
      if (sourceRef) {
        _this.sourceRect = (sourceRef.current || sourceRef).getBoundingClientRect();
      }
      return _this.sourceRect;
    });
    _defineProperty(_assertThisInitialized(_this), "setTooltipRect", function () {
      if (_this.tooltipRef.current) {
        _this.tooltipRect = _this.tooltipRef.current.getBoundingClientRect();
      }
      return _this.tooltipRect;
    });
    _defineProperty(_assertThisInitialized(_this), "setPortalRect", function () {
      var _this$props3 = _this.props,
        portalId = _this$props3.portalId,
        inline = _this$props3.inline;
      if (portalId && !inline) {
        _this.portalRect = document.getElementById(portalId).getBoundingClientRect();
      }
      return _this.portalRect;
    });
    _defineProperty(_assertThisInitialized(_this), "findScrollParent", function () {
      var _this$props4 = _this.props,
        sourceRef = _this$props4.sourceRef,
        scrollRef = _this$props4.scrollRef,
        scrollRefs = _this$props4.scrollRefs,
        listenToAllParentScrolls = _this$props4.listenToAllParentScrolls;
      var scrollParents = [];
      if (scrollRef) {
        scrollParents = [scrollRef.current || scrollRef];
      } else if (scrollRefs) {
        scrollParents = scrollRefs.map(function (ref) {
          return ref.current || ref;
        });
      } else {
        var el = sourceRef;
        while (el && el.parentNode && el.parentNode !== document) {
          el = el.parentNode;
          var style = getComputedStyle(el);
          if (style && (style["overflow-y"] === "scroll" || style["overflow-y"] === "auto" || style["overflow-x"] === "scroll" || style["overflow-x"] === "auto" || style["overflow"] === "scroll" || style["overflow"] === "auto")) {
            scrollParents = [].concat(_toConsumableArray(scrollParents), [el]);
            if (!listenToAllParentScrolls) {
              break;
            }
          }
        }
        if (listenToAllParentScrolls) {
          scrollParents = [].concat(_toConsumableArray(scrollParents), [window]);
        }
      }
      scrollParents.forEach(function (el) {
        if (el && !_this.scrollParents.includes(el)) {
          el.addEventListener("scroll", _this.onScroll);
          _this.scrollParents.push(el);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onScroll", function () {
      if (!_this.throttling) {
        _this.throttling = true;
        _this.setPosition();
        window.requestAnimationFrame(function () {
          if (_this.unmounted) return;
          _this.throttling = false;
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getStyles", (0, _memoizeOne["default"])(function (style, boxStyle, tailStyle, getTransitionStyle, entering, duration, position) {
      var _style = _objectSpread(_objectSpread({}, style), getTransitionStyle && getTransitionStyle(entering, duration, position)),
        transition = _style.transition,
        transitionProperty = _style.transitionProperty,
        _style$transitionDura = _style.transitionDuration,
        transitionDuration = _style$transitionDura === void 0 ? "".concat(duration, "ms") : _style$transitionDura,
        _style$transitionTimi = _style.transitionTimingFunction,
        transitionTimingFunction = _style$transitionTimi === void 0 ? "ease-out" : _style$transitionTimi,
        transitionDelay = _style.transitionDelay,
        transform = _style.transform,
        padding = _style.padding,
        opacity = _style.opacity,
        rest = _objectWithoutProperties(_style, _excluded);
      var transitionStyle = null;
      if (transition) {
        transitionStyle = {
          transition: transition
        };
      } else if (transitionProperty) {
        transitionStyle = {
          transitionProperty: transitionProperty,
          transitionDuration: transitionDuration,
          transitionTimingFunction: transitionTimingFunction,
          transitionDelay: transitionDelay
        };
      }
      var mergedBoxStyle = _objectSpread(_objectSpread({}, boxStyle), rest);
      var mergedMaskStyle = Object.entries(mergedBoxStyle).reduce(function (style, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (!/^border/.test(key) && !/^padding/.test(key) && key !== "boxShadow" || key === "borderRadius") {
          style[key] = value;
        }
        return style;
      }, {});
      return {
        boxStyle: _objectSpread(_objectSpread({
          transform: transform,
          padding: padding,
          opacity: opacity
        }, mergedBoxStyle), transitionStyle),
        maskStyle: _objectSpread(_objectSpread({}, mergedMaskStyle), transitionStyle),
        tailStyle: _objectSpread(_objectSpread(_objectSpread({}, tailStyle), rest), transitionStyle)
      };
    }));
    _defineProperty(_assertThisInitialized(_this), "getTooltipStyle", (0, _memoizeOne["default"])(function (top, left, interactive) {
      return {
        position: "absolute",
        zIndex: 10,
        pointerEvents: !interactive && "none",
        top: top,
        left: left
      };
    }));
    _defineProperty(_assertThisInitialized(_this), "getInteractiveStyle", (0, _memoizeOne["default"])(function (position, tailHeight, offset, sourceWidth, sourceHeight, offsetWidth, offsetHeight) {
      var totalOffset = tailHeight + offset;
      var positionStyle = null;
      switch (position) {
        case "left":
        case "left-start":
        case "left-end":
          positionStyle = {
            right: -totalOffset,
            top: offsetHeight,
            width: totalOffset
          };
          break;
        case "bottom":
        case "bottom-start":
        case "bottom-end":
          positionStyle = {
            top: -totalOffset,
            left: offsetWidth,
            height: totalOffset
          };
          break;
        case "right":
        case "right-start":
        case "right-end":
          positionStyle = {
            left: -totalOffset,
            top: offsetHeight,
            width: totalOffset
          };
          break;
        default:
          positionStyle = {
            bottom: -totalOffset,
            left: offsetWidth,
            height: totalOffset
          };
          break;
      }
      return _objectSpread({
        position: "absolute",
        width: sourceWidth,
        height: sourceHeight
      }, positionStyle);
    }));
    _defineProperty(_assertThisInitialized(_this), "getMaskStyle", (0, _memoizeOne["default"])(function (maskStyle) {
      return _objectSpread({
        width: "100%",
        height: "100%",
        position: "absolute",
        zIndex: 1,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: "auto"
      }, maskStyle);
    }));
    _defineProperty(_assertThisInitialized(_this), "getTailStyle", (0, _memoizeOne["default"])(function (position, tailHeight, tailStyle, offsetBody, sourceWidth, sourceHeight, offsetWidth, offsetHeight) {
      var vertical = !(position === "right" || position === "left");
      var start = !(position === "bottom" || position === "right");
      var style = _objectSpread({
        width: tailHeight * 1.41,
        height: tailHeight * 1.41,
        position: "absolute",
        zIndex: 0
      }, tailStyle);
      switch (position) {
        case "right":
        case "right-start":
        case "right-end":
          return _objectSpread({
            top: sourceHeight / 2 + offsetHeight - offsetBody,
            bottom: 0,
            left: 0,
            transform: "translate(-50%, -50%) rotate(45deg)"
          }, style);
        case "bottom":
        case "bottom-start":
        case "bottom-end":
          return _objectSpread({
            top: 0,
            right: 0,
            left: sourceWidth / 2 + offsetWidth - offsetBody,
            transform: "translate(-50%, -50%) rotate(45deg)"
          }, style);
        case "left":
        case "left-start":
        case "left-end":
          return _objectSpread({
            top: sourceHeight / 2 + offsetHeight - offsetBody,
            right: 0,
            bottom: 0,
            transform: "translate(50%, -50%) rotate(45deg)"
          }, style);
        default:
          return _objectSpread({
            right: 0,
            bottom: 0,
            left: sourceWidth / 2 + offsetWidth - offsetBody,
            transform: "translate(-50%, 50%) rotate(45deg)"
          }, style);
      }
    }));
    _defineProperty(_assertThisInitialized(_this), "getPortalElement", (0, _memoizeOne["default"])(function (portalId) {
      var element = document.getElementById(portalId);
      if (!element && process.env.NODE_ENV !== "production") {
        throw new Error("Could not find DOM element with ID ".concat(portalId, " to inject. Please provide a portalId which matches an existing DOM element or render a TooltipPortal as a parent to this element."));
      }
      return element;
    }));
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props5 = _this.props,
        children = _this$props5.children,
        portalId = _this$props5.portalId,
        inline = _this$props5.inline,
        tailHeight = _this$props5.tailHeight,
        offset = _this$props5.offset,
        offsetBody = _this$props5.offsetBody,
        entering = _this$props5.entering,
        duration = _this$props5.duration,
        interactive = _this$props5.interactive,
        getTransitionStyle = _this$props5.getTransitionStyle,
        style = _this$props5.style,
        propBoxStyle = _this$props5.boxStyle,
        propTailStyle = _this$props5.tailStyle,
        boxClassName = _this$props5.boxClassName,
        maskClassName = _this$props5.maskClassName,
        tailClassName = _this$props5.tailClassName;
      var _this$state = _this.state,
        top = _this$state.top,
        left = _this$state.left,
        absoluteTop = _this$state.absoluteTop,
        absoluteLeft = _this$state.absoluteLeft,
        position = _this$state.position;
      var element = null;
      if (!inline && portalId) {
        element = _this.getPortalElement(portalId);
      }
      var _this$getStyles = _this.getStyles(style, propBoxStyle, propTailStyle, getTransitionStyle, entering, duration, position),
        boxStyle = _this$getStyles.boxStyle,
        maskStyle = _this$getStyles.maskStyle,
        tailStyle = _this$getStyles.tailStyle;
      var _this$sourceRect = _this.sourceRect,
        sourceTop = _this$sourceRect.top,
        sourceLeft = _this$sourceRect.left,
        sourceWidth = _this$sourceRect.width,
        sourceHeight = _this$sourceRect.height;
      var offsetWidth = sourceLeft - absoluteLeft;
      var offsetHeight = sourceTop - absoluteTop;
      var tooltip = /*#__PURE__*/_react["default"].createElement("div", {
        style: _this.getTooltipStyle(top, left, interactive),
        ref: _this.tooltipRef
      }, interactive && /*#__PURE__*/_react["default"].createElement("div", {
        style: _this.getInteractiveStyle(position, tailHeight, offset, sourceWidth, sourceHeight, offsetWidth, offsetHeight)
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: boxStyle,
        className: boxClassName
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: "relative",
          zIndex: 2
        }
      }, children), tailHeight > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        style: _this.getMaskStyle(maskStyle),
        className: maskClassName
      }), tailHeight > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        style: _this.getTailStyle(position, tailHeight, tailStyle, offsetBody, sourceWidth, sourceHeight, offsetWidth, offsetHeight),
        className: tailClassName
      })));
      return element ? /*#__PURE__*/(0, _reactDom.createPortal)(tooltip, element) : tooltip;
    });
    return _this;
  }
  return _createClass(Tooltip);
}(_react.Component);
_defineProperty(Tooltip, "propTypes", _objectSpread(_objectSpread({}, tooltipPropTypes), {}, {
  children: _propTypes["default"].node.isRequired,
  sourceRef: _propTypes["default"].instanceOf(Element),
  entering: _propTypes["default"].bool,
  duration: _propTypes["default"].number
}));
_defineProperty(Tooltip, "defaultProps", {
  position: "top",
  getTransitionStyle: getDefaultTransitionStyle,
  style: defaultStyle,
  boxStyle: defaultBoxStyle,
  tailHeight: defaultTailHeight,
  offset: defaultOffset,
  offsetBody: defaultOffsetBody,
  portalId: null,
  pure: true,
  inline: false,
  interactive: false,
  autoFlip: true,
  listenToAllParentScrolls: false
});
_defineProperty(Tooltip, "scrollers", []);